export function flattenSlides(slides) {
	let result = [];
	slides.forEach(slide => {
		result.push(slide);
		if (Array.isArray(slide.children)) result = result.concat(flattenSlides(slide.children));
	});

	return result;
}